import React from 'react';
import { LabelledMultiSelect } from '../../../../../../../../components/LabelledMultiSelect';
import { ApplicationListingFilters } from '../../utils';
import { Col } from 'reactstrap';

interface PropTypes {
  isLoading: boolean;
  filters: ApplicationListingFilters;
  setFilters: (filters: ApplicationListingFilters) => void;
}

const JOB_STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
  { value: 'archived', label: 'Archived' },
];

export function JobStatusFilter(props: PropTypes) {
  return (
    <Col xs='3' className='mt-3h'>
      <LabelledMultiSelect
        label='Job Status'
        placeholder='Select Job Status'
        singleSelectedText='1 status selected'
        manySelectedText='%d statuses selected'
        options={JOB_STATUS_OPTIONS}
        onChange={(jobStatuses) =>
          props.setFilters({ ...props.filters, jobStatuses })
        }
        className='ps-0 fs-5 fw-semibold'
        disabled={props.isLoading}
        selected={props.filters?.jobStatuses || []}
        hasSelectAll={true}
      />
    </Col>
  );
}
